import styled from 'styled-components';

import {
  Accordion,
  Form,
  Image, Radio as SemanticRadio,
  Checkbox as SemanticCheckbox,
} from 'semantic-ui-react';
import ReactSlider from 'react-slider';

import {
  Button as ButtonLayoutComponent,
  Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled.div`
  ${({ noMarginTop }) => !noMarginTop && 'margin-top: 25px;'}
`;

const FormContainer = styled.div``;

const Text = styled(TextLayoutComponent)``;

const Header = styled(TextLayoutComponent.Header)`
  font-size: 18px;
  margin-bottom: 5px;
`;

const SectionTitle = styled(TextLayoutComponent.Header)`
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 10px;

  &&&&&&&&& {
    margin: 0px !important;
  }
`;

const HeaderQuestions = styled(TextLayoutComponent.Header)`
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 5px;
  margin-top: 40px;
`;

const SegmentTitle = styled(TextLayoutComponent.Bold)``;

const TextError = styled(TextLayoutComponent)`
  font-size: 18px;
  margin: 10px 0;
  text-align: center;
`;

const ContainerNumberParticipants = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: ${(props) => props.marginBottom}px;
`;

const InputContainer = styled.div`
  flex: 1;
  margin-left: 20px;

  .ui.input {
    width: 100% !important;
  }
`;

const FloatRight = styled.div`
  display: inline-block;
  float: right;
  font-weight: normal;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const TrashIcon = styled(Image)`
  cursor: pointer;
  height: 20px;
`;

const QuestionSegment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    background: ${(props) => props.theme.color.segmentCreateProjectBackground};
    padding: 20px;
    flex: 2;
  }
`;

const SectionContainer = styled.div`
  margin-bottom: 20px;
`;

const HeaderSegmentContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
  margin-right: 23px;
`;

const AnswersContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin: 10px 0;
`;

const InputAnswerContainer = styled.div`
  flex: 1;
  width: 320px;
  display: flex;
`;

const QualifyContainer = styled.div`
  display: flex;
  margin: 0 20px;
  width: 120px;
`;

const IconCircle = styled(Image)`
  cursor: pointer;
  height: 20px;
  width: 20px;
`;

const ContainerAccordion = styled.div`
  padding: 5px 0;
`;

const CustomAccordion = styled(Accordion)`
  &&& {
    border-radius: 0;
    border: solid 1px ${(props) => props.theme.color.checkboxAccordion};
    box-shadow: 0 0 #fff;
    margin: 0;
  }
`;

const QuestionField = styled(Form.Field)`
  &&&&& {
    min-width: 100% !important;
    margin: 0px;
  }
`;

const ScreenerQuestionContainer = styled.div`
  margin: 10px 0;
`;

const AddScreenerQuestion = styled.a`
  cursor: pointer;
  margin-top: 10px;
`;

const SingleSelectionContainer = styled.div`
  margin-bottom: 15px;
  margin-top: 20px;
`;

const AddQuestion = styled.a`
  cursor: pointer;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 80px;
`;

const NextButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 125px;
  }
`;

const BackButton = styled(ButtonLayoutComponent.Inverted)`
  &.ui.button {
    margin-right: 60px;
    width: 125px;
  }
`;

const SetUpContainer = styled.div`
  ${({ marginTop }) => marginTop && `
    margin-top: 6px;
  `}
`;

const RadioContainer = styled.div`
  display: flex;
  margin: 10px;
  align-items: center;
  cursor: ${({ notalowedcursor }) => (notalowedcursor ? 'not-allowed' : 'pointer')};
`;

const Radio = styled(SemanticRadio)`
  margin-right: 5px;
  &&&& > label {
    cursor: ${({ notalowedcursor }) => (notalowedcursor ? 'not-allowed' : 'pointer')};
  }
`;

const ImageComponent = styled(Image)`
  &.ui.image {
    height: 20px;
    width: 20px;
    margin-right: 10px;
  }
`;

const ErrorMessage = styled(TextLayoutComponent)`
  text-align: center;
  color: red;
`;

const Checkbox = styled(SemanticCheckbox)`
  &&& {
    margin-right: 10px;
  }
`;

const ContainerSavedAudience = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const SliderContainer = styled.div`
  width: 90%;
  margin: auto;
`;

const SliderInfos = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 14px 5px 0 5px;
`;

const Slider = styled(ReactSlider)`
    width: 100%;
`;

const SliderThumb = styled.div`
    position: absolute;
    top: -8px;
    width: 20px;
    height: 20px;
    text-align: center;
    color: #fff;
    cursor: grab;
    border-radius: 100%;
    background-color: rgb(255, 255, 255);
    box-shadow: rgb(34 36 38 / 15%) 0px 1px 2px 0px, rgb(34 36 38 / 15%) 0px 0px 0px 1px inset;
`;

const SliderTrack = styled.div`
    position: relative;
    height: 4px;
    background: ${(props) => (props.index === 1 ? '#477ae9' : '#ddd')};
    border-radius: 999px;
`;

const ActionContainer = styled.div`
  width: 22%;
  display: flex;
`;

const ActionLink = styled.a`
  float: right;
  margin-right: 25px;
`;

export {
  AddQuestion,
  AddScreenerQuestion,
  AnswersContainer,
  BackButton,
  ButtonContainer,
  Container,
  ContainerAccordion,
  ContainerNumberParticipants,
  CustomAccordion,
  FloatRight,
  FormContainer,
  Header,
  HeaderQuestions,
  HeaderSegmentContainer,
  IconCircle,
  InputAnswerContainer,
  InputContainer,
  NextButton,
  QualifyContainer,
  QuestionField,
  QuestionSegment,
  ScreenerQuestionContainer,
  SectionContainer,
  SectionTitle,
  SegmentTitle,
  SingleSelectionContainer,
  SliderContainer,
  Slider,
  SliderThumb,
  SliderTrack,
  SliderInfos,
  Text,
  TextError,
  TrashIcon,
  SetUpContainer,
  RadioContainer,
  Radio,
  ImageComponent,
  ErrorMessage,
  Checkbox,
  ContainerSavedAudience,
  ActionContainer,
  ActionLink,
};
